// 平台子系統入口(業主 2026-07-12:所有子系統都能從 admin 找到進入點)。
//
// URL 由 admin 自身 host 推導,自動適配 dev/prod:admin 在 v3-admin-{env}.ls-dg.net,
// 其餘子系統在 v3-{name}-{env}.ls-dg.net(把 host 的 "v3-admin" 換成 "v3-{name}")。
// 少數不遵循此樣式的(docs 為 Outline、無 v3- 前綴)以絕對網址直給。localhost/未知
// host → 退回 dev 網址。外開新分頁、rel=noopener。

interface Subsystem {
  key: string;
  label: string;
  desc: string;
  icon: string;
  /** derive from admin host by token swap, or an absolute URL for off-pattern hosts. */
  name?: string;
  absolute?: string;
}

const GROUPS: { title: string; items: Subsystem[] }[] = [
  {
    title: '開發與生態',
    items: [
      { key: 'devportal', label: '開發者入口', desc: 'Developer Portal — 開發者/組織自助、機型與整合', icon: '🧑‍💻', name: 'devportal' },
      { key: 'emu', label: '裝置模擬器', desc: 'Emulator — 模擬機隊、送事件/媒體', icon: '🎛️', name: 'emu' },
      { key: 'fw', label: '韌體伺服器', desc: 'Firmware — OTA 上傳與釋出', icon: '💽', name: 'fw' },
    ],
  },
  {
    title: '觀測與支援',
    items: [
      { key: 'helpdesk', label: 'Help Desk', desc: '第一線維運支援台(L1)— 帳號由維運團隊授權', icon: '🎧', name: 'hd' },
      { key: 'grafana', label: '監控與日誌', desc: 'Grafana — 指標、儀表板、Loki 日誌', icon: '📈', name: 'grafana' },
      { key: 'dashboard', label: '數據儀表板', desc: 'Dashboard — 營運數據總覽', icon: '📊', name: 'dashboard' },
      { key: 'docs', label: '說明文件 / 知識庫', desc: 'Outline — 平台文件與作業手冊', icon: '📚', absolute: 'https://docs.ls-dg.net' },
    ],
  },
  {
    title: '客戶端與基礎設施',
    items: [
      { key: 'webapp', label: 'Home Web', desc: '公版 Web App(Kinio / 品牌生態)', icon: '🏠', name: 'webapp' },
      { key: 'aura', label: 'Aura Web', desc: 'AI 管家 Web', icon: '✨', name: 'aura' },
      { key: 'signalca', label: '憑證 CA', desc: 'Signaling CA — 裝置憑證簽發鏈', icon: '🔐', name: 'signalca' },
      { key: 'api', label: 'REST API', desc: 'restful-api — /v3 服務入口', icon: '🔌', name: 'api' },
    ],
  },
];

function subsystemUrl(s: Subsystem): string {
  if (s.absolute) return s.absolute;
  const host = typeof window !== 'undefined' ? window.location.host : '';
  if (host.startsWith('v3-admin')) return `https://${host.replace('v3-admin', 'v3-' + s.name)}`;
  return `https://v3-${s.name}-dev.ls-dg.net`; // localhost / unknown → dev default
}

export function SubsystemLauncher() {
  return (
    <section className="dashboard-panel dsh-subsystems" data-testid="subsystem-launcher">
      <div className="dashboard-panel-head">
        <h2>平台子系統</h2>
        <span className="text-tertiary">於新分頁開啟</span>
      </div>
      {GROUPS.map((g) => (
        <div key={g.title} className="dsh-sub-group">
          <div className="dsh-sub-group-title text-tertiary">{g.title}</div>
          <div className="dsh-sub-grid">
            {g.items.map((s) => (
              <a key={s.key} className="dsh-sub-card" href={subsystemUrl(s)} target="_blank" rel="noopener noreferrer">
                <span className="dsh-sub-icon" aria-hidden="true">
                  {s.icon}
                </span>
                <span className="dsh-sub-body">
                  <span className="dsh-sub-label">
                    {s.label} <span className="dsh-sub-ext" aria-hidden="true">↗</span>
                  </span>
                  <span className="dsh-sub-desc text-tertiary">{s.desc}</span>
                </span>
              </a>
            ))}
          </div>
        </div>
      ))}
    </section>
  );
}
